export const getThemeClasses = (theme) => {
  const isDark = theme === "dark";

  return {
    isDark,

    // 🌟 Text Colors
    baseText: isDark ? "text-gray-200" : "text-gray-800",
    hoverText: isDark ? "hover:text-pink-400" : "hover:text-blue-600",
    titleColor: isDark ? "text-cyan-400" : "text-gray-900",
    overlayText: isDark ? "text-gray-100" : "text-gray-700",

    // 🎨 Background Colors
    bgColor: isDark ? "bg-[#121212]" : "bg-[#DBD4FF]",  // softer than plain white
    scrollContainerBg: isDark ? "bg-[#1e1e1e]" : "#e9e6fc",
    overlayBg: isDark ? "bg-black/50" :"bg-[#e9e6fc]",

    // 🗂️ Border Colors
    borderColor: isDark ? "border-cyan-400" : "border-gray-300",
    hoverBorder: isDark ? "hover:border-pink-400" : "hover:border-blue-400",

    // 🌙 Toggle Button
    toggleButton: isDark
      ? "border-gray-500 text-gray-200"
      : "border-gray-300 text-gray-700",

    // 🎮 CTA / Explore Button
    exploreBtn: isDark
      ? "bg-cyan-400 text-black hover:bg-pink-500 hover:text-white"
      : "bg-blue-500 text-white hover:bg-pink-500",
  };
};
